import { Logger } from "@base-provider";
import { NoSpacesRegex } from "../../constants/regex";
export const translateError = (t) => (error, translate) => {
  Logger.of("App.components.formBuilder.translateError").info({ error });
  
  let msg = error.message;
  switch (error.keyword) {
  case "required":
    msg = t("components.formBuilder.errors.required");
    break;
  case "minLength":
    msg = t("components.formBuilder.errors.minLength", {
      minLength: error.params.limit,
    });
    break;
  case "maxLength":
    msg = t("components.formBuilder.errors.maxLength", {
      maxLength: error.params.limit,
    });
    break;
  case "type":
    msg = t("components.formBuilder.errors.type", {
      type: error.params.type,
    });
    break;
  case "format":
    msg = t("components.formBuilder.errors.format", {
      format: error.params.format,
    });
    break;
  case "pattern":
    if (error.params.pattern === NoSpacesRegex) {
      msg = t("components.formBuilder.errors.patternNoSpaces");
    } else {
      msg = t("components.formBuilder.errors.pattern");
    }
    break;

  default:
    break;
  }
  return msg;
};
